var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import * as React from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { NumericTextBox } from '@progress/kendo-react-inputs';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import { messages, filterClearButton } from '../messages';
import { registerForLocalization, provideLocalizationService } from '@progress/kendo-react-intl';
import { cellBoolDropdownChange, cellInputChange, cellOperatorChange } from '../filterCommon';

var GridFilterCell = function (_super) {
  __extends(GridFilterCell, _super);

  function GridFilterCell(props) {
    var _this = _super.call(this, props) || this;

    _this.renderOperatorEditor = function () {
      if (_this.props.filterType === 'boolean') {
        return;
      }

      var value = _this.props.operators.find(function (item) {
        return item.operator === _this.props.operator;
      }) || null;
      return React.createElement(DropDownList, {
        value: value,
        onChange: _this.operatorChange,
        className: "k-dropdown-operator",
        iconClassName: "k-i-filter k-icon",
        data: _this.props.operators,
        textField: "text",
        popupSettings: {
          width: ''
        }
      });
    };

    _this.inputChange = _this.inputChange.bind(_this);
    _this.clear = _this.clear.bind(_this);
    _this.operatorChange = _this.operatorChange.bind(_this);
    _this.boolDropdownChange = _this.boolDropdownChange.bind(_this);
    return _this;
  }
  /**
   * @hidden
   */


  GridFilterCell.prototype.render = function () {
    var localizationService = provideLocalizationService(this);
    var defaultRendering = React.createElement("div", {
      className: "k-filtercell"
    }, React.createElement("div", {
      className: "k-filtercell-wrapper"
    }, this.filterComponent(this.props.filterType, this.props.value, this.props.booleanValues), React.createElement("div", {
      className: "k-filtercell-operator"
    }, this.renderOperatorEditor(), React.createElement("button", {
      className:
      /* button is always visible if there is either value or operator */
      !(this.props.value === null || this.props.value === '') || this.props.operator ? 'k-button k-button-icon k-clear-button-visible' : 'k-button k-button-icon',
      title: localizationService.toLanguageString(filterClearButton, messages[filterClearButton]),
      type: "button",
      onClick: this.clear
    }, React.createElement("span", {
      className: "k-icon k-i-filter-clear"
    })))));

    if (this.props.render) {
      return this.props.render.call(undefined, defaultRendering, this.props);
    }

    return defaultRendering;
  };

  GridFilterCell.prototype.inputChange = function (value, e) {
    cellInputChange(value, e, this.props);
  };

  GridFilterCell.prototype.operatorChange = function (event) {
    cellOperatorChange(event, this.props.value, this.props.onChange);
  };

  GridFilterCell.prototype.boolDropdownChange = function (event) {
    cellBoolDropdownChange(event, this.props.onChange);
  };

  GridFilterCell.prototype.clear = function (e) {
    e.preventDefault();
    this.props.onChange({
      value: '',
      operator: '',
      syntheticEvent: e
    });
  };

  GridFilterCell.prototype.filterComponent = function (filterType, value, booleanValues) {
    var _this = this;

    switch (filterType) {
      case 'numeric':
        return React.createElement(NumericTextBox, {
          value: value,
          onChange: function onChange(e) {
            _this.inputChange(e.value, e.syntheticEvent);
          }
        });

      case 'date':
        return React.createElement(DatePicker, {
          value: value,
          onChange: function onChange(e) {
            _this.inputChange(e.value, e.syntheticEvent);
          }
        });

      case 'boolean':
        var noFilterSet_1 = function noFilterSet_1(filter) {
          return filter === null || filter === undefined;
        };

        return React.createElement(DropDownList, {
          onChange: this.boolDropdownChange,
          value: booleanValues.find(function (item) {
            return item.operator === (noFilterSet_1(value) ? '' : value);
          }),
          data: booleanValues,
          textField: "text"
        });

      default:
        return React.createElement("input", {
          className: "k-textbox",
          value: value || '',
          onChange: function onChange(e) {
            _this.inputChange(e.target.value, e);
          }
        });
    }
  };

  return GridFilterCell;
}(React.Component);

export { GridFilterCell };
registerForLocalization(GridFilterCell);